import {
  Button,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@e2n/ui/v2';
import { DesktopKalender } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/desktop';
import { KalenderViewOptions } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/desktop/components/KalenderViewOptions';
import { YearNavigationHeader } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/desktop/components/YearNavigationHeader';
import { Uebersicht } from '@/domain/mitarbeiter/features/rotationsplan/features/Plaene/Uebersicht';
import { VorlagenUebersicht } from '@/domain/mitarbeiter/features/rotationsplan/features/Vorlagen/Uebersicht';
import { useRotationsplanFeatureContext } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/RotationsplanFeatureContext';
import {
  faLayerGroup,
  faPlus,
  faUserGroup,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import { KalenderLoading } from '@/domain/mitarbeiter/features/rotationsplan/components/KalenderLoading';

/* eslint-disable max-lines-per-function */
export function DesktopPage({
  view,
  isStandorteUpdatePending,
}: {
  view: string;
  isStandorteUpdatePending: boolean;
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { store } = useRotationsplanFeatureContext();
  const kalenderWocheRef = useRef<HTMLDivElement | null>(null);

  return (
    <div className="flex flex-col gap-8">
      <Tabs
        value={view}
        onValueChange={(value) => {
          navigate(`/mitarbeiter/rotationsplaene/${value}`, { replace: true });
        }}>
        <div className="flex w-full justify-between">
          <TabsList variant="on-grey">
            <TabsTrigger value="planung">
              {t('domain.mitarbeiter.rotationsplan.tabs.planung')}
            </TabsTrigger>
            <TabsTrigger value="uebersicht">
              {t('domain.mitarbeiter.rotationsplan.tabs.rotationsplaene')}
            </TabsTrigger>
            {/* <TabsTrigger value="vorlagen">
              {t('domain.mitarbeiter.rotationsplan.tabs.vorlagen')}
            </TabsTrigger> */}
          </TabsList>
          {view === 'uebersicht' && (
            <Link
              key="uebersicht"
              to={`/mitarbeiter/rotationsplaene/uebersicht/create`}
              replace>
              <Button iconOnly>
                <FontAwesomeIcon icon={faPlus} />
              </Button>
            </Link>
          )}
          {view === 'vorlagen' && (
            <Link
              key="vorlagen"
              to={`/mitarbeiter/rotationsplaene/vorlagen/create`}
              replace>
              <Button iconOnly>
                <FontAwesomeIcon icon={faPlus} />
              </Button>
            </Link>
          )}
        </div>

        <TabsContent className="mt-6" value="planung">
          <Tabs defaultValue="mitarbeiter_rotationsplanKalenderByArbeitsbereiche">
            <div className="relative flex flex-col gap-4 w-full min-h-125 bg-white rounded-md items-start justify-start p-4">
              <div className="w-full flex items-start justify-between">
                <div className="flex flex-col gap-2">
                  <YearNavigationHeader kalenderWocheRef={kalenderWocheRef} />
                  <KalenderViewOptions />
                </div>
                <TabsList>
                  <Tooltip>
                    <TooltipTrigger>
                      <TabsTrigger
                        onClick={() =>
                          store.setKalenderView('byArbeitsbereiche')
                        }
                        value="mitarbeiter_rotationsplanKalenderByArbeitsbereiche">
                        <FontAwesomeIcon
                          className="size-3.5!"
                          icon={faLayerGroup}
                        />
                      </TabsTrigger>
                    </TooltipTrigger>
                    <TooltipContent>
                      {t(
                        'domain.mitarbeiter.rotationsplan.tabs.anzeigeNachArbeitsbereichenTooltip',
                      )}
                    </TooltipContent>
                  </Tooltip>
                  <Tooltip>
                    <TooltipTrigger>
                      <TabsTrigger
                        onClick={() => store.setKalenderView('byMitarbeiter')}
                        value="mitarbeiter_rotationsplanKalenderByMitarbeiter">
                        <FontAwesomeIcon
                          className="size-3.5!"
                          icon={faUserGroup}
                        />
                      </TabsTrigger>
                    </TooltipTrigger>
                    <TooltipContent>
                      {t(
                        'domain.mitarbeiter.rotationsplan.tabs.anzeigeNachMitarbeitendenTooltip',
                      )}
                    </TooltipContent>
                  </Tooltip>
                </TabsList>
              </div>
              <TabsContent
                asChild
                value="mitarbeiter_rotationsplanKalenderByArbeitsbereiche">
                <DesktopKalender
                  view="arbeitsbereiche"
                  key="kalenderArbeitsbereiche"
                  kalenderWocheRef={kalenderWocheRef}
                />
              </TabsContent>
              <TabsContent
                asChild
                value="mitarbeiter_rotationsplanKalenderByMitarbeiter">
                <DesktopKalender
                  view="mitarbeiter"
                  key="kalenderMitarbeiter"
                  kalenderWocheRef={kalenderWocheRef}
                />
              </TabsContent>
              {isStandorteUpdatePending && <KalenderLoading />}
            </div>
          </Tabs>
        </TabsContent>
        <TabsContent className="mt-4" value="uebersicht">
          <Uebersicht />
        </TabsContent>
        <TabsContent className="mt-4" value="vorlagen">
          <VorlagenUebersicht />
        </TabsContent>
      </Tabs>
      <Outlet />
    </div>
  );
}
